import Footer from "@/components/Footer";
import FrontNav from "@/components/FrontNav";
import Marquee from "react-fast-marquee";
import Head from "next/head";
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/outline";
import { Fade, Slide } from "react-awesome-reveal";
import Link from "next/link";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import { useTranslation, Trans } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ScrollChart from "@/components/3d/ScrollChart";
import { CheckIcon } from "@heroicons/react/20/solid";

const tiers = [
  {
    name: "Standard Access",
    id: "Standard",
    href: "#",
    price: "$19.99",
    description: "Basic and standard access to get started.",
    features: [
      "Unlimited Team",
      "Basic Modules",
      "Basic Access",
      "Basic Analytics",
      "24/48-hour support response time",
    ],
    featured: false,
    cta: "Buy plan",
  },
  {
    name: "Full Access",
    id: "Full",
    href: "#",
    price: "$500",
    description: "Access everything we provide. And more.",
    features: [
      "Everything Standard",
      "Unlimited Modules",
      "Advanced Analytics",
      "4-hour Dedicated Support",
      "Custom Modules",
    ],
    featured: false,
    cta: "Buy plan",
  },
];

const featuredTestimonial = {
  body: "We needed to have 2 employees working processing and locating routes for our orders, however with oinkbit, we were able to automate the entire process and now have 1 employee overseeing the system and handling exceptions. We are saving over $1M annually on labor costs alone.",
  author: {
    name: "Amanda Zhang",
    handle: "azupin_glass",
    imageUrl:
      "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=1024&h=1024&q=80",
    logoUrl: "https://i.imgur.com/on4QEAb.png",
  },
};
const testimonials = [
  [
    [
      {
        body: "Taking payments and estimating was easier than ever.",
        author: {
          name: "Jose Navarro",
          handle: "sapphire_x_glass",
          imageUrl:
            "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop,q=95/AVLNbvnBKouqnWyl/sg-logo-05-mnl59xL5j4sxRgrR.png",
        },
      },
      {
        body: "They functions of managing multiple warehouses and deductions were too easy to set up and use. We were able to save so much time and labor costs.",
        author: {
          name: "Frank Wang",
          handle: "sunshine_materials",
          imageUrl:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyF0f3jAt8_TEKg3RL_20EOxtm4K3T_vzBPw&s",
        },
      },
      {
        body: "The team was very responsive and helpful in setting up the system to fit our needs. We were able to automate many processes and save a lot of time.",
        author: {
          name: "Haifeng",
          handle: "haifengconstructionco",
          imageUrl:
            "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        },
      },
    ],
    [
      {
        body: "Custom tailored a module to our liking and only for a small fee. They really care about their customers and are always looking for ways to improve and help us succeed.",
        author: {
          name: "Kobi Mo",
          handle: "kobiworks",
          imageUrl:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAGuPZbId_qOw7TYnaZnD2TlcmVzDkC3cAzg&s",
        },
      },
      {
        body: "Easily integrated with my current system to process emails and campaigns.",
        author: {
          name: "Joey Ma",
          handle: "furbun",
          imageUrl: "https://foxomy.com/logotail.svg",
        },
      },
    ],
  ],
  [
    [
      {
        body: "I can invoice my customers and track payments all in one place. It has made my life so much easier.",
        author: {
          name: "Isaiah",
          handle: "isaiah",
          imageUrl:
            "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        },
      },
      {
        body: "The system is very user friendly and the support team is always available to help with any questions or issues. We were able to automate many processes and save a lot of time.",
        author: {
          name: "Whitney Francis",
          handle: "whitneyfrancis",
          imageUrl:
            "https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        },
      },
    ],
    [
      {
        body: "They went above and beyond! They were able to custom tailor a module to our liking and only for a small fee. They really care about their customers and are always looking for ways to improve and help us succeed.",
        author: {
          name: "Leonard Krasner",
          handle: "leonardkrasner",
          imageUrl:
            "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        },
      },
      {
        body: "The team was very responsive and helpful in setting up the system to fit our needs. We were able to automate many processes and save a lot of time.",
        author: {
          name: "Floyd Miles",
          handle: "floydmiles",
          imageUrl:
            "https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        },
      },
      {
        body: "What a great experience! The team was very responsive and helpful in setting up the system to fit our needs. We were able to automate many processes and save a lot of time.",
        author: {
          name: "Emily Selman",
          handle: "emilyselman",
          imageUrl:
            "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        },
      },
    ],
  ],
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Home = () => {
  const { t, i18n } = useTranslation("home");

  return (
    <>
      <Head>
        <title>{t("meta.title")}</title>
      </Head>
      <FrontNav />

      <section className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 lg:pt-0 pt-10">
        <main className="flex flex-col lg:flex-row items-center justify-center">
          <div className="flex flex-col space-y-4 flex-1 min-w-0">
            <div className="">
              <div className="px-2 py-1 rounded-lg inline-flex flex-row bg-neutral-800 max-w-full text-xs sm:text-sm text-neutral-200 group cursor-pointer duration-300 shadow">
                <p>
                  oinkbit saves $1M on labor. |{" "}
                  <span className="font-semibold group-hover:text-blue-200 duration-300">
                    Learn More
                  </span>
                </p>
              </div>
            </div>
            <h1 className="tracking-tighter text-3xl sm:text-4xl lg:text-5xl font-semibold">
              Drive growth confidently with tools that assists you.
            </h1>
            <p className="text-sm sm:text-base">
              Take control of your business from one place, manage, track and
              view all your data in a modern professional dashboard. Integrate
              and customize anything at a single request.
            </p>
            <div>
              <button className="rounded-full px-6 py-2 bg-black text-white">
                Get Started
              </button>
            </div>
          </div>

          <div className="relative w-full overflow-hidden flex-1">
            <img
              src="https://i.imgur.com/SLG23Z7.png"
              className="w-full block"
            />

            {/* Edge fade */}
            <div
              className="pointer-events-none absolute inset-0"
              style={{
                background: `
        radial-gradient(circle at center,
          transparent 60%,
          rgba(255,255,255,0.7) 85%,
          white 100%
        )
      `,
              }}
            />
          </div>
        </main>

        <div className="mt-10 p-4 sm:px-10 sm:pt-10 bg-gradient-conic from-black to-blue-100 rounded-lg border">
          <img src="https://files.catbox.moe/fj76tw.png" className="w-full" />
        </div>

        {/* logo list */}
        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-6 items-center justify-items-center my-8">
          <img
            src="https://i.imgur.com/LlXeoye.png"
            className="w-20 sm:w-28 lg:w-32"
          />
          <img
            src="https://i.imgur.com/vJi8YpK.png"
            className="w-20 sm:w-28 lg:w-32"
          />
          <img
            src="https://famfonts.com/wp-content/uploads/home-depot-wide.png"
            className="w-20 sm:w-28 lg:w-32"
          />
          <img
            src="https://i.imgur.com/on4QEAb.png"
            className="w-20 sm:w-28 lg:w-32"
          />
          <img
            src="https://assets.tailwindplus.com/logos/11.svg?color=black&height=32"
            className="w-20 sm:w-28 lg:w-32"
          />
          <img
            src="https://1000logos.net/wp-content/uploads/2023/03/Lowes-Logo-1970.png"
            className="w-20 sm:w-28 lg:w-32"
          />
        </div>

        <div className="my-16 sm:my-24 lg:my-32">
          <h4 className="font-semibold tracking-tight text-sm sm:text-base">
            Core Features
          </h4>
          <h3 className="font-serif text-3xl sm:text-4xl lg:text-6xl tracking-tight">
            Powerful tools at a glance
          </h3>
          <p className="text-neutral-600 lg:w-1/2 mt-2 text-sm sm:text-base">
            Manage all your business operations in one place with our powerful
            suite of tools.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="p-3 border border-neutral-300 rounded-lg flex-1">
              <div className="pt-6 px-4 sm:pt-10 sm:px-10 bg-gradient-conic from-blue-100 to-blue-800 rounded-lg border overflow-hidden">
                <img
                  src="https://i.imgur.com/vcpBNyp.png"
                  className="w-full rounded-t-lg aspect-video object-cover object-left"
                />
              </div>
              <div className="p-3 sm:p-4">
                <h4 className="text-base sm:text-lg font-semibold">
                  Enhances Sales Person Data
                </h4>
                <p className="text-neutral-600 text-xs sm:text-sm">
                  Get a complete view of your sales person data, including
                  performance, commissions, and more.
                </p>
                <button className="mt-4 text-sm font-medium text-blue-600 hover:text-blue-800">
                  Learn More
                </button>
              </div>
            </div>
            <div className="p-3 border border-neutral-300 rounded-lg flex-1">
              <div className="pt-6 px-4 sm:pt-10 sm:px-10 bg-gradient-conic from-green-100 to-green-800 rounded-lg border overflow-hidden">
                <img
                  src="https://i.imgur.com/1WK919n.png"
                  className="w-full rounded-t-lg aspect-video object-cover object-left"
                />
              </div>
              <div className="p-3 sm:p-4">
                <h4 className="text-base sm:text-lg font-semibold">
                  Home Depot Orders Management
                </h4>
                <p className="text-neutral-600 text-xs sm:text-sm">
                  Take control of importing, managing and fulfilling your Home
                  Depot orders with ease.
                </p>
                <button className="mt-4 text-sm font-medium text-blue-600 hover:text-blue-800">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="my-16 sm:my-24 lg:my-32">
          <h4 className="font-semibold tracking-tight text-sm sm:text-base">
            Built for SCALE
          </h4>
          <h3 className="font-serif text-3xl sm:text-4xl lg:text-6xl tracking-tight">
            Delivers results and success.
          </h3>
          <p className="text-neutral-600 lg:w-1/2 mt-2 text-sm sm:text-base">
            We take your problems personally, dynamically adjusting and creating
            tools that would make your life easier and business more efficient.
          </p>

          <div className="lg:relative flex lg:flex-row flex-col items-start justify-start">
            <div className="lg:absolute mt-10">
              <h4 className="text-neutral-800 font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
                $100M+
              </h4>
              <p className="text-neutral-500 text-sm sm:text-base">
                Processed through us, managing new, small, big or complex
                enterprises.
              </p>
            </div>
            <div className="w-full overflow-hidden">
              <ScrollChart
                showLabels={false}
                showGrid={false}
                showDots={true}
                lineColor="#262626"
                padding={{ top: 10, right: 10, bottom: 10, left: 10 }}
              />
            </div>
          </div>
        </div>

        <div className="my-16 sm:my-24 lg:my-32">
          <h4 className="font-semibold tracking-tight text-sm sm:text-base">
            Testimonials
          </h4>
          <h3 className="font-serif text-3xl sm:text-4xl lg:text-6xl tracking-tight">
            Trust our clients' success stories,{" "}
            <br className="hidden sm:block" />
            not just our words.
          </h3>
          <p className="text-neutral-600 lg:w-1/2 mt-2 text-sm sm:text-base">
            Success testimonials from verifiable sources and companies across
            the globe.
          </p>

          <div>
            <div className="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 gap-4 sm:gap-8 text-sm/6 text-gray-900 mt-10 sm:grid-cols-2 xl:mx-0 xl:max-w-none xl:grid-flow-col xl:grid-cols-4">
              <figure className="rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
                <blockquote className="p-4 sm:p-6 text-base sm:text-lg font-semibold tracking-tight text-gray-900 sm:p-12 sm:text-xl/8">
                  <p>{`"${featuredTestimonial.body}"`}</p>
                </blockquote>
                <figcaption className="flex flex-wrap items-center gap-x-4 gap-y-4 border-t border-gray-900/10 px-4 sm:px-6 py-4 sm:flex-nowrap">
                  <img
                    alt=""
                    src={featuredTestimonial.author.imageUrl}
                    className="size-10 flex-none rounded-full bg-gray-50"
                  />
                  <div className="flex-auto min-w-0">
                    <div className="font-semibold text-gray-900 truncate">
                      {featuredTestimonial.author.name}
                    </div>
                    <div className="text-gray-600 truncate">{`@${featuredTestimonial.author.handle}`}</div>
                  </div>
                  <img
                    alt=""
                    src={featuredTestimonial.author.logoUrl}
                    className="h-8 sm:h-10 w-auto flex-none"
                  />
                </figcaption>
              </figure>
              {testimonials.map((columnGroup, columnGroupIdx) => (
                <div
                  key={columnGroupIdx}
                  className="space-y-4 sm:space-y-8 xl:contents xl:space-y-0"
                >
                  {columnGroup.map((column, columnIdx) => (
                    <div
                      key={columnIdx}
                      className={classNames(
                        (columnGroupIdx === 0 && columnIdx === 0) ||
                          (columnGroupIdx === testimonials.length - 1 &&
                            columnIdx === columnGroup.length - 1)
                          ? "xl:row-span-2"
                          : "xl:row-start-1",
                        "space-y-4 sm:space-y-8",
                      )}
                    >
                      {column.map((testimonial) => (
                        <figure
                          key={testimonial.author.handle}
                          className="rounded-2xl bg-white p-4 sm:p-6 shadow-lg ring-1 ring-gray-900/5"
                        >
                          <blockquote className="text-gray-900 text-sm sm:text-base">
                            <p>{`"${testimonial.body}"`}</p>
                          </blockquote>
                          <figcaption className="mt-4 sm:mt-6 flex items-center gap-x-4">
                            <img
                              alt=""
                              src={testimonial.author.imageUrl}
                              className="size-8 sm:size-10 rounded-full bg-gray-50"
                            />
                            <div className="min-w-0">
                              <div className="font-semibold text-gray-900 text-sm truncate">
                                {testimonial.author.name}
                              </div>
                              <div className="text-gray-600 text-xs sm:text-sm truncate">{`@${testimonial.author.handle}`}</div>
                            </div>
                          </figcaption>
                        </figure>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="group/tiers bg-white my-16 sm:my-24 lg:my-32">
          <div className="mx-auto">
            <h3 className="font-serif text-3xl sm:text-4xl lg:text-6xl tracking-tight text-center">
              Pricing that fits anyone.
            </h3>

            <div className="isolate mx-auto mt-10 sm:mt-16 lg:mt-20 flex lg:flex-row flex-col justify-center max-w-md gap-4 sm:gap-8 lg:mx-0 lg:max-w-none">
              {tiers.map((tier) => (
                <div
                  key={tier.id}
                  data-featured={true}
                  className="group/tier rounded-3xl p-6 sm:p-8 ring-1 ring-gray-200 data-featured:bg-gray-900 data-featured:ring-gray-900 xl:p-10 flex-1"
                >
                  <h3
                    id={`tier-${tier.id}`}
                    className="text-base sm:text-lg/8 font-semibold text-gray-900 group-data-featured/tier:text-white"
                  >
                    {tier.name}
                  </h3>
                  <p className="mt-3 sm:mt-4 text-xs sm:text-sm/6 text-gray-600 group-data-featured/tier:text-gray-300">
                    {tier.description}
                  </p>
                  <p className="mt-4 sm:mt-6 flex items-baseline gap-x-1 group-not-has-[[name=frequency][value=monthly]:checked]/tiers:hidden">
                    <span className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 group-data-featured/tier:text-white">
                      {tier.price}
                    </span>
                    <span className="text-xs sm:text-sm/6 font-semibold text-gray-600 group-data-featured/tier:text-gray-300">
                      /month
                    </span>
                  </p>

                  <button
                    value={tier.id}
                    name="tier"
                    type="submit"
                    aria-describedby={`tier-${tier.id}`}
                    className="mt-4 sm:mt-6 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm/6 font-semibold text-white shadow-xs group-data-featured/tier:bg-white/10 group-data-featured/tier:inset-ring group-data-featured/tier:inset-ring-white/5 hover:bg-indigo-500 group-data-featured/tier:hover:bg-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 group-data-featured/tier:focus-visible:outline-white/75"
                  >
                    {tier.cta}
                  </button>
                  <ul
                    role="list"
                    className="mt-6 sm:mt-8 space-y-3 text-xs sm:text-sm/6 text-gray-600 group-data-featured/tier:text-gray-300 xl:mt-10"
                  >
                    {tier.features.map((feature) => (
                      <li key={feature} className="flex gap-x-3">
                        <CheckIcon
                          aria-hidden="true"
                          className={classNames(
                            tier.featured ? "text-white" : "text-indigo-600",
                            "h-5 sm:h-6 w-4 sm:w-5 flex-none",
                          )}
                        />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "home",
        "common",
        "frontNav",
        "footer",
      ])),
    },
  };
}

export default Home;
